import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: ('admin' | 'head_of_department' | 'teacher')[]
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { user, role, loading } = useAuth()

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0f111a',
        color: '#ffffff'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  // If the user's profile is not yet created or is pending admin approval,
  // redirect them to the registration page which displays either the signup form or the success/pending screen.
  if (!user.status || user.status === 'pending_approval') {
    return <Navigate to="/register" replace />
  }

  if (allowedRoles && role && !allowedRoles.includes(role as any)) {
    // If user role is not allowed, redirect to their home portal
    if (role === 'admin') return <Navigate to="/admin" replace />
    if (role === 'head_of_department') return <Navigate to="/department" replace />
    return <Navigate to="/teacher" replace />
  }

  return <>{children}</>
}
